// extracted by mini-css-extract-plugin
export default {"root":"error_root__VVOiL","description":"error_description__5RpJB","title":"error_title__d5w56","closeButton":"error_closeButton__LoSJD"};